import { FaPlus } from 'react-icons/fa'
import styled from 'styled-components';

const AddButtonHousing = styled.button`
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  cursor: pointer;
  color: #B9B9B9;
  background-color: #E0DEDE;
  font-size: 1.3em;
`;

const AddButton = (props) => {
  return (
    <AddButtonHousing
      type={props.type}
      onClick={props.onClick}
    >
      <FaPlus/>
    </AddButtonHousing>
  )
}

export default AddButton;
